<template>
    <div class="l-ss-c-results">
        <div class="l-ss-c-empty-results">
            <p class="l-ss-c-text-caption">{{ $t('results.getPopularError') }}</p>
        </div>
        <div>
            <h2 class="l-ss-c-results-categories-category-title">
                <span class="l-ss-c-results-categories-category-title-value">
                    {{ $t('results.getPopular') }}
                </span>
            </h2>&nbsp;
            <offers-wrapper
                :offers="offers"
                offers-type="popular"
                view="grid"
                :offer-props="{ 'data-page': null }"
                @offer-click="params => $emit('offer-click', params)"
                @add-to-cart="offer => $emit('add-to-cart', offer)"
                @go-to-cart="offer => $emit('go-to-cart', offer)"/>
        </div>
        <div class="l-ss-c-results-empty-message">
            <div class="l-ss-c-empty-results">
                <button
                    class="l-ss-c-button l-ss-c-button-large"
                    @click="$emit('clickEmptyResult', $event)">
                    {{ $t('categories.emptyListButtonResetQuery') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import OffersWrapper from '@/core/components/offers-wrapper';

    export default {
        name: 'popular-offers',
        components: { OffersWrapper },
        props: {
            offers: {
                type: Array,
                default: () => [],
            },
        },
    };
</script>
